import React from 'react';
import { Download } from 'lucide-react';
import api from '../../lib/api';

export const iso = (d) => d.toISOString().slice(0, 10);

export const PRESETS = () => {
  const t = new Date();
  const y = t.getFullYear();
  const m = t.getMonth();
  const mk = (from, to) => ({ from: iso(from), to: iso(to) });
  return [
    ['today', 'Hoje', mk(t, t)],
    ['d7', '7 dias', mk(new Date(y, m, t.getDate() - 6), t)],
    ['d30', '30 dias', mk(new Date(y, m, t.getDate() - 29), t)],
    ['month', 'Este mês', mk(new Date(y, m, 1), t)],
    ['prev', 'Mês passado', mk(new Date(y, m - 1, 1), new Date(y, m, 0))],
    ['ytd', 'Ano', mk(new Date(y, 0, 1), t)],
    ['all', 'Tudo', { from: '', to: '' }],
  ];
};

export const Ribbon = ({ items, testid }) => (
  <div className="ent-panel ent-ribbon" data-testid={testid}>
    {items.filter(Boolean).map(([label, value, cls]) => (
      <div key={label} className="px-4 py-3">
        <p className="ent-label">{label}</p>
        <p className={`ent-value num mt-1 ${cls || ''}`}>{value}</p>
      </div>
    ))}
  </div>
);

export const GroupTabs = ({ tabs, value, onChange, testid }) => (
  <div className="ent-tabs" data-testid={testid}>
    {tabs.map(([k, l]) => (
      <button key={k} data-testid={`${testid}-${k}`} onClick={() => onChange(k)} className={`ent-tab ${value === k ? 'ent-tab-active' : ''}`}>{l}</button>
    ))}
  </div>
);

export const DataTable = ({ cols, rows, testid, empty = 'Sem dados no período', rowKey }) => (
  <div className="overflow-x-auto">
    <table className="ent-table" data-testid={testid}>
      <thead>
        <tr>{cols.map((c) => <th key={c.key} className={c.align === 'right' ? 'text-right' : c.hide || ''}>{c.label}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={rowKey ? r[rowKey] || i : i} data-testid={`${testid}-row-${i}`}>
            {cols.map((c) => (
              <td key={c.key} className={`${c.align === 'right' ? 'text-right num' : ''} ${c.hide || ''} ${c.cls ? c.cls(r) : ''}`}>
                {c.render ? c.render(r) : (r[c.key] ?? '—')}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    {!rows.length && <p className="ent-empty">{empty}</p>}
  </div>
);

export const csvDownload = async (url, filename) => {
  try {
    const res = await api.get(url, { responseType: 'blob' });
    const href = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = href; a.download = filename; a.click();
    URL.revokeObjectURL(href);
  } catch (e) {}
};

export const CsvButton = ({ url, filename, testid }) => (
  <button data-testid={testid} onClick={() => csvDownload(url, filename)} className="ent-btn h-8 px-3">
    <Download className="h-3.5 w-3.5" /> CSV
  </button>
);

export const PeriodBar = ({ range, setRange, onApply, children, testid }) => (
  <div className="ent-panel p-3 flex flex-wrap items-end gap-2" data-testid={testid}>
    <div className="flex flex-wrap gap-1 mr-1">
      {PRESETS().map(([k, l, r]) => (
        <button key={k} data-testid={`preset-${k}`} onClick={() => { setRange(r); onApply(r); }}
          className={`ent-pill px-2.5 py-1 ${range.from === r.from && range.to === r.to ? 'border-primary text-foreground' : ''}`}>{l}</button>
      ))}
    </div>
    <div><p className="ent-label mb-1">De</p><input data-testid="range-from" type="date" className="ent-input" value={range.from} onChange={(e) => setRange({ ...range, from: e.target.value })} /></div>
    <div><p className="ent-label mb-1">Até</p><input data-testid="range-to" type="date" className="ent-input" value={range.to} onChange={(e) => setRange({ ...range, to: e.target.value })} /></div>
    {children}
    <button data-testid="apply-filters" onClick={() => onApply()} className="ent-btn ent-btn-primary h-8 px-4">Aplicar</button>
  </div>
);

export const Select = ({ label, value, onChange, options, testid, allLabel = 'Todos' }) => (
  <div>
    <p className="ent-label mb-1">{label}</p>
    <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} className="ent-input" style={{ minWidth: 132 }}>
      <option value="" className="bg-popover text-foreground">{allLabel}</option>
      {options.map((o) => <option key={o} value={o} className="bg-popover text-foreground">{o}</option>)}
    </select>
  </div>
);
